import { defineHeroThemeContract, type HeroThemeTokens } from '../../../art/contract';

/**
 * The sage hero's THEME (ADR-0099 / ADR-0102 / ADR-0117) — a deep-blue + purple + gold spellbook palette pulled
 * from her painted art, with a starry indigo-night sky (her own world). Choosing her recolours the WHOLE kid
 * shell: the brand ramp drives buttons / meters / rings in enchanted purple, the canvas washes blue to a soft
 * gold-dawn, and the hero stage takes her starry indigo night. Every brand colour is paired with its own
 * foreground for legibility.
 */
export const sageTheme: HeroThemeTokens = defineHeroThemeContract({
  // BRAND RAMP — enchanted purple. `soft`→`primary` is the button/meter gradient (white text); `deep` is on-light
  // text (≈ 7:1 on the light kid surfaces); `tint` is the softest fill; `glow-rgb` = #7A54C9 for coloured shadows.
  '--color-primary': '#7A54C9',
  '--color-primary-fg': '#FFFFFF',
  '--color-primary-soft': '#9673DC',
  '--color-primary-deep': '#4C2F8E',
  '--color-primary-tint': '#EBE3F9',
  '--color-primary-glow-rgb': '122 84 201',
  '--color-secondary': '#E2E6F7',
  '--color-secondary-fg': '#2B2C63',
  '--color-accent': '#FFCF5A',
  '--color-accent-fg': '#4A3A00',
  // CANVAS — a deep-blue bloom top-left, a soft-gold bloom bottom-right (an enchanted study behind the content).
  '--canvas-a': '#E3E7F8',
  '--canvas-b': '#FCF1D6',
  // A starry indigo-night sky (white text stays AA over it).
  '--sky-top': '#1b1f47',
  '--sky-mid': '#3a4fb0',
  '--sky-low': '#8f7fd6',
  '--sky-glow': '#ffe6a8',
  '--sky-fg': '#ffffff',
});
